import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { CircularProgress, Grid, Link, Typography, Button } from "@mui/material";
import moment from "moment";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";
import OtpInput from "react18-input-otp";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hoc";
import { emailReg } from "@/constants/CommonRegex";
import VaModal from "../va-modal/va-modal";
import VaTextField from "../va-text-field/va-text-field";
import { ErrorSpan, StyledLink } from "./email-verification-validate-otp-style";
import { vritiApiClient } from "@/hoc/api/api-service";
import { useMutation } from "@tanstack/react-query";
import { writeAccessToken } from '@/utils/auth-token-store';
const EmailVerificationValidateOtpModal = ({ sendVerificationEmail, sendVerificationEmailState, emailVerificationVerifyOtpState, sendVerificationEmailPartialReset, emailEditable = true, sendVerificationEmailReset, setSecondTimeSignupPopup, emailVerificationVerifyOtp, setExitEmail, setSuccessfulSignUp, setEmailVerifyOtpVisible, token, visible, formData, initialState = "", setFormData, setVisible, }) => {
    const [countDown, setCountDown] = useState(120); // in seconds
    const navigate = useNavigate();
    const [uiState, setUiState] = useState(initialState ? initialState : "otp");
    const { showToast } = useToast();
    const [error, setError] = useState({
        email: "",
        emailTouched: false,
        otpError: "",
    });
    //callbacks
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        const { email = "" } = formData;
        isValidEmail(email);
    }, [formData === null || formData === void 0 ? void 0 : formData.email]);
    useEffect(() => {
        const interval = setInterval(() => {
            if (countDown > 0)
                setCountDown(countDown - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [countDown]);
    useEffect(() => {
        const { otp = "" } = formData;
        handleChangeOtp(otp);
    }, [formData === null || formData === void 0 ? void 0 : formData.otp]);
    const { mutate: verifyEmail, isPending: isVerifyEmailPending } = useMutation({
        mutationFn: (data) => vritiApiClient.post(`auth/send-verify-email/`, Object.assign({}, data), { skipAppName: true }),
        onSuccess: (data) => {
            showToast({ message: data === null || data === void 0 ? void 0 : data.message, status: 'success' });
            setSuccessfulSignUp(false);
            setExitEmail(false);
            setEmailVerifyOtpVisible(true);
        },
        onError: (error) => {
            console.log("error in login", error);
            showToast({
                message: 'Failed to verify.',
                description: error.message,
                status: 'error',
            });
        },
    });
    useEffect(() => {
        if (!isVerifyEmailPending) {
            setCountDown(120);
            if (formData.isSecondaryEmailVerify) {
                setUiState("otp");
            }
        }
    }, [isVerifyEmailPending]);
    const { mutate: verifyOtp, isPending: isVerifyOtpPending } = useMutation({
        mutationFn: (data) => vritiApiClient.post(`auth/otp-verify/`, Object.assign({}, data)),
        onSuccess: (data) => {
            console.log("verify otp data api sucess", data);
            showToast({ message: data === null || data === void 0 ? void 0 : data.message, status: 'success' });
            if (token) {
                writeAccessToken(token);
                navigate(`/company-details`);
            }
            else {
                setSecondTimeSignupPopup(true);
            }
            setEmailVerifyOtpVisible(false);
        },
        onError: (error) => {
            showToast({
                message: 'Failed to verify.',
                description: error.message,
                status: 'error',
            });
        },
    });
    // functions
    const isValidEmail = (email) => {
        if (!email) {
            setError(Object.assign(Object.assign({}, error), { email: "Required", emailTouched: true }));
            return;
        }
        if (email.trim().split(" ").length > 1) {
            setError(Object.assign(Object.assign({}, error), { email: "Extra space is not allowed" }));
            return;
        }
        if (isNaN(email) && !emailReg.test(email)) {
            setError(Object.assign(Object.assign({}, error), { emailOrMobile: "Enter a valid Email address" }));
            return;
        }
        setError(Object.assign(Object.assign({}, error), { email: "" }));
    };
    const handleSendOtp = () => {
        const { email = "" } = formData;
        if (!email) {
            setError(Object.assign(Object.assign({}, error), { email: "Required", emailTouched: true }));
            return;
        }
        if (!isNaN(email) && email.trim().length !== 10) {
            setError(Object.assign(Object.assign({}, error), { email: "Enter a valid mobile number" }));
            return;
        }
        if (isNaN(email) && !emailReg.test(email)) {
            setError(Object.assign(Object.assign({}, error), { email: "Enter a valid email address" }));
            return;
        }
        setError(Object.assign(Object.assign({}, error), { email: "" }));
        let payload = {
            email: email,
            account_type: "organization",
        };
        if (formData === null || formData === void 0 ? void 0 : formData.isSecondaryEmailVerify) {
            payload["email_type"] = (formData === null || formData === void 0 ? void 0 : formData.isSecondaryEmailVerify) ? "secondary" : null;
        }
        verifyEmail(payload);
    };
    const resendOtp = () => {
        const { otp = "", email = "" } = formData;
        let payload = {
            email: email,
            account_type: "organization",
        };
        if (formData === null || formData === void 0 ? void 0 : formData.isSecondaryEmailVerify) {
            payload["email_type"] = (formData === null || formData === void 0 ? void 0 : formData.isSecondaryEmailVerify) ? "secondary" : null;
        }
        verifyEmail(payload);
        setError(Object.assign(Object.assign({}, error), { otpError: "" }));
    };
    const handleChangeOtp = (otp) => {
        if (otp && otp.length !== 6) {
            setError(Object.assign(Object.assign({}, error), { otpError: "Enter valid OTP" }));
        }
        setError(Object.assign(Object.assign({}, error), { otpError: "" }));
    };
    const handleVerifyOtp = () => {
        const { otp = "", email = "" } = formData;
        if (!otp) {
            setError(Object.assign(Object.assign({}, error), { otpError: "Enter OTP" }));
            return;
        }
        if (otp && otp.length !== 6) {
            setError(Object.assign(Object.assign({}, error), { otpError: "Enter valid OTP" }));
            return;
        }
        if (email && !emailReg.test(email)) {
            setError(Object.assign(Object.assign({}, error), { email: "Enter a valid email address" }));
            return;
        }
        setError(Object.assign(Object.assign({}, error), { otpError: "" }));
        // preparing payload
        let payload = {};
        if (isNaN(email)) {
            payload["email"] = email;
            payload["otp"] = otp;
            payload["is_this_verification"] = true;
            if (formData === null || formData === void 0 ? void 0 : formData.isSecondaryEmailVerify) {
                payload["email_type"] = (formData === null || formData === void 0 ? void 0 : formData.isSecondaryEmailVerify) ? "secondary" : null;
            }
            verifyOtp(Object.assign(Object.assign({}, payload), { account_type: "organization" }));
        }
        setFormData(Object.assign(Object.assign({}, formData), { otp: "" }));
    };
    return (_jsx("div", { children: _jsx(VaModal, { id: "email-verification-modal", title: "Verify Email", visible: visible, setVisible: () => {
                setUiState("email-only");
                setVisible(false);
            }, children: _jsx("div", { children: ["email-only", "otp"].includes(uiState) && (_jsxs(Grid, { textAlign: "start", children: [_jsx(VaTextField, { id: "email-id", label: "Email ID", fullWidth: true, disabled: !emailEditable, name: "email", placeholder: "Enter your valid Email ID", error: Boolean(error.email) && error.emailTouched, errorMessage: error.emailTouched && error.email, value: formData === null || formData === void 0 ? void 0 : formData.email, inputProps: { readOnly: uiState === "otp" ? true : false }, onFocus: (e) => {
                                setError(Object.assign(Object.assign({}, error), { emailOrMobileTouched: true }));
                            }, onChange: (e) => {
                                setError(Object.assign(Object.assign({}, error), { emailOrMobileTouched: true }));
                                setFormData(Object.assign(Object.assign({}, formData), { email: e.target.value }));
                            }, onBlur: (e) => {
                                setError(Object.assign(Object.assign({}, error), { emailTouched: true }));
                            } }), uiState === "otp" && (_jsxs("div", { children: [_jsxs("div", { style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }, children: [_jsx(Link, { style: { cursor: "pointer", color: '#2a19d2' }, underline: "none", children: moment.utc(countDown * 1000).format("mm:ss") }), _jsx(StyledLink, { underline: "none", disabled: countDown > 0 || isVerifyEmailPending, onClick: resendOtp, children: isVerifyEmailPending ? "Sending..." : "Resend OTP" })] }), _jsx(Typography, { style: {
                                        marginBottom: "6px",
                                    }, children: "Enter OTP which is sent to your Email ID *" }), _jsx(OtpInput, { id: "otp-verification-input", numInputs: 6, value: formData.otp, onChange: (event) => {
                                        setFormData(Object.assign(Object.assign({}, formData), { otp: event }));
                                    }, onSubmit: handleVerifyOtp, inputStyle: {
                                        border: "none",
                                        borderRadius: "8px",
                                        width: "70px",
                                        height: "54px",
                                        fontSize: "12px",
                                        color: "#000",
                                        fontWeight: "400",
                                        backgroundColor: "rgb(222 227 241)",
                                        caretColor: "blue",
                                    }, focusStyle: {
                                        border: "1px solid #CFD3DB",
                                        outline: "none",
                                    }, separator: _jsx("span", { style: { width: "10px" } }), isInputNum: true, shouldAutoFocus: true }), _jsx(ErrorSpan, { children: error.otpError })] })), _jsxs("div", { className: "grid", children: [uiState === "email-only" && (_jsx(Button, { id: "email-verification-send-otp", fullWidth: true, variant: "contained" // or "outlined"/"text" depending on your style
                                    , color: "primary", "data-testid": "sign-up", onClick: handleSendOtp, 
                                    // Send OTP runs verifyEmail, so lock on that request (not the verify one)
                                    disabled: isVerifyEmailPending, sx: { position: "relative" }, children: isVerifyEmailPending ? (_jsx(CircularProgress, { size: 24, color: "inherit", sx: { position: "absolute", left: "50%", transform: "translateX(-50%)" } })) : ("Send OTP") })), uiState === "otp" && (_jsx(Button, { id: "email-verification-verify-otp", fullWidth: true, variant: "contained", color: "primary", style: { borderRadius: '10px' }, onClick: handleVerifyOtp, disabled: isVerifyOtpPending, sx: { mt: 2, alignSelf: 'center', backgroundColor: '#2a19d2' }, children: isVerifyOtpPending ? (_jsx(CircularProgress, { size: 24, color: "inherit", sx: { position: "absolute", left: "50%", transform: "translateX(-50%)" } })) : ("Verify OTP") }))] })] })
                // <OtpVAlidation uiState={uiState} setUiState={setUiState} setFormData={setFormData} formData={formData} />
                ) }) }) }));
};
EmailVerificationValidateOtpModal.propTypes = {
    emailVerificationVerifyOtp: PropTypes.func.isRequired,
    sendVerificationEmail: PropTypes.func.isRequired,
    emailVerificationVerifyOtpState: PropTypes.object.isRequired,
};
export default EmailVerificationValidateOtpModal;
